import React from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { ContentAnalyzer, MavenPositive } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { SplitButton } from 'uiToolkitV1/SplitButton';
import { TagColored } from 'uiToolkitV1/Tag';
import BetaTag from 'uiToolkitV1/Tag/BetaTag';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const ProposeAISection = () => (
  <PaperWithShadow
    p="16px"
    bg="linear-gradient(91deg, rgba(0, 142, 240, 0.03) 1.81%, rgba(236, 59, 100, 0.03) 36.92%, rgba(255, 194, 0, 0.03) 69.52%, rgba(92, 196, 97, 0.03) 106.15%)"
    border="1px solid"
    borderColor="#B3D9FF"
    h="100%"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
  >
    <Box>
      {/* Header with title and status */}
      <Flex alignItems="center" justifyContent="space-between" mb="12px">
        <Flex alignItems="center" gap="8px">
          <MavenPositive boxSize="20px" />
          <TextBodyMedium bold>Fairness analysis</TextBodyMedium>
          <BetaTag />
        </Flex>
        <TagColored color="red">Needs review</TagColored>
      </Flex>

      {/* Divider below header */}
      <Divider color="neutral.EBEFF3" m="1px 0 12px 0" />

      {/* Analysis description */}
      <TextBodyMedium color="#424242" mb="16px" lineHeight="1.5">
        The current compensation decisions show uneven application of merit guidelines, and multiple outliers suggest a
        disconnect between performance and pay outcomes. Some roles or teams may require rebalancing to ensure fairness
        and compliance.
      </TextBodyMedium>
    </Box>
    {/* Action buttons */}
    <Flex gap="12px">
      <Button variant="filled" height="32px" StartIcon={ContentAnalyzer}>
        Analyze
      </Button>

      <SplitButton
        isGradient
        options={[
          {
            label: 'Auto optimize',
            onClick: () => {},
          },
          {
            label: 'Rebalance',
            onClick: () => {},
          },
        ]}
        indexesToRender={[0, 1]}
        buttonProps={{}}
        menuButtonProps={{}}
        menuProps={{}}
      />
    </Flex>
  </PaperWithShadow>
);
